var dP = require('./_object-dp');
var createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};



//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/core-js@2.6.12/~/core-js/modules/_hide.js
// module id = ../../../../../../core-js@2.6.12/node_modules/core-js/modules/_hide.js
// module chunks = 0